import { c as d } from "../../../index-Cu0xwYjD.js";
import { usePopover as l } from "../../Popover/hooks/usePopover.js";
const c = "ids-menu-v501", o = "ids-menu--inline-v501", a = "ids-menu--stack-v501", v = "ids-menu--fluid-v501", e = {
  menu: c,
  inline: o,
  "inline-equal-width": "ids-menu--inline-equal-width-v501",
  stack: a,
  fluid: v,
  "ids-menu-item--divider": "ids-menu-item--divider-v501"
}, p = ({
  className: s,
  fluid: t,
  layout: u = "stack",
  role: m
}) => {
  const n = l(), i = n == null ? void 0 : n.type;
  return {
    className: d(s, e.menu, e[u], {
      [e.fluid]: i && ["listbox", "menu"].includes(i) || t,
      [e.nav]: m === "nav" && e.nav
    })
  };
};
export {
  p as useMenuStyles
};
